<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'住院费用'" :fixed="true"> </Nav>
      <div class="top"></div>
    </div>
    <div class="list"> 
      <van-collapse v-model="activeNames" accordion v-for="(item1,index1) in 4" :key="index1">
         <van-cell  value="2021-01-05" class="date" />
        <van-collapse-item v-for="(item,index) in 2" :key="index" >
             <template #title> 
      <div class="title">
        <div class="title_name">血细胞分析 </div>
      <div class="title_money">费用：￥20</div>
      </div>
    </template>
            <van-cell title="ww" value="aa" />
            <van-cell title="ww" value="aa" />
            <van-cell title="ww" value="aa" />
            <van-cell title="ww" value="aa" />
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
export default {
   data() {
    return {
      activeNames: [],
    };
  },
  components: {
    Nav,
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  .top{
      height: 50px;
  }
  .list{
    .date{
      background-color: #eee;
    }
    .title{
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      .title_name{
         font-size: 14px;
      }
      .title_money{
         font-size: 14px;
      }
    }
  }
}
</style>